import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  deviceInfo,
  adapterAssetList,
  updateDeviceStolenStatus,
  updateDeviceLockStatus,
  resetDevicePin
} from '../../redux/actions'

import Device from '../../components/device'


class DevicePage extends Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  getBackLink = () => {
    const params = new URLSearchParams(this.props.location.search)
    return params.get('from') === 'adapters' ? '/devices?view=adapters' : '/devices'
  }

  render() {
    const {
      translate,
      deviceInfo,
      device,
      adapterAssets,
      adapterAssetList,
      updateDeviceLockStatus,
      updateDeviceStolenStatus,
      resetDevicePin,
      user
    } = this.props
    const { params } = this.props.match

    return (
      <Device
        translate={translate}
        deviceInfo={deviceInfo}
        deviceId={params.deviceid}
        device={device}
        adapterAssets={adapterAssets}
        adapterAssetList={adapterAssetList}
        user={user}
        backLink={this.getBackLink()}
        updateDeviceStolenStatus={updateDeviceStolenStatus}
        updateDeviceLockStatus={updateDeviceLockStatus}
        resetDevicePin={resetDevicePin}
        hasLrpFreeFeatures={this.props.activeFeatures?.some(feature => feature.featureName === 'lrp_free_features')}
      />
    )
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  deviceInfo: (id) => {
    dispatch(deviceInfo(id))
  },
  adapterAssetList: () => {
    dispatch(adapterAssetList())
  },
  updateDeviceStolenStatus: (id, stolen) => {
    dispatch(updateDeviceStolenStatus(id, stolen))
  },
  updateDeviceLockStatus: (id, status) => {
    dispatch(updateDeviceLockStatus(id, status))
  },
  resetDevicePin: (id) => {
    dispatch(resetDevicePin(id))
  }
})

const mapStateToProps = (state) => ({
  device: state.deviceReducer.device,
  adapterAssets: state.deviceReducer.adapterAssets,
  user: state.userReducer.user,
  activeFeatures: state.appSettingReducer.activeFeatures
})

export default connect(mapStateToProps, mapDispatchToProps)(DevicePage)
